var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-0 pt-0"},[_c('div',{staticClass:"flexBlock pd-block"},[_c('h3',{staticClass:"custom-h3"},[_vm._v("История оценок")])])])])
}]

export { render, staticRenderFns }